import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propFunc, propId, propStr, } from '../../../../../../../helpers/custom-prop-types';
import ProffitSearchFolderShareCommentContent from '../../Common/ShareCommentContent';
import ProffitSearchFolderShareCommentProfile from '../../Common/ShareCommentProfile';
import ReceivedButton from './ReceivedButton';
const ReceivedUser = (props) => {
    const { content, createdAt, firstName, id, lastName, onClick, photo, receivedAt, } = props;
    return (_jsxs("div", Object.assign({ className: 'proffit_search_receive_information_user_col' }, { children: [_jsx(ProffitSearchFolderShareCommentProfile, { className: 'receive_profile', createdAt: createdAt, dateFormatSuffix: '受領', name: `${lastName} ${firstName}`, photo: photo }), _jsx(ProffitSearchFolderShareCommentContent, { className: 'receive_comment', content: content }), _jsx(ReceivedButton, { className: 'receive_button', id: id, onClick: onClick, receivedAt: receivedAt })] })));
};
ReceivedUser.propTypes = {
    content: propStr().isRequired,
    createdAt: propStr().isRequired,
    firstName: propStr().isRequired,
    id: propId().isRequired,
    lastName: propStr().isRequired,
    onClick: propFunc().isRequired,
    photo: propStr(),
    receivedAt: propStr(),
};
ReceivedUser.defaultProps = {
    photo: '',
    receivedAt: null,
};
export default ReceivedUser;
